// ISO 3166-1 alpha-2 to alpha-3 country code mapping
export const countryCodeMap = {
  KR: "KOR",
  US: "USA",
  JP: "JPN",
  CN: "CHN",
  GB: "GBR",
  CA: "CAN",
  AU: "AUS",
  FR: "FRA",
  DE: "DEU",
  ES: "ESP",
  IT: "ITA",
  TH: "THA",
  VN: "VNM",
  PH: "PHL",
  MY: "MYS",
  SG: "SGP",
  ID: "IDN",
  IN: "IND",
  HK: "HKG",
  TW: "TWN",
  NZ: "NZL",
  BR: "BRA",
  MX: "MEX",
  RU: "RUS",
  NL: "NLD",
  BE: "BEL",
  CH: "CHE",
  SE: "SWE",
  NO: "NOR",
  DK: "DNK",
  FI: "FIN",
  PL: "POL",
  PT: "PRT",
  IE: "IRL",
  AT: "AUT",
  GR: "GRC",
  TR: "TUR",
  IL: "ISR",
  AE: "ARE",
  SA: "SAU",
  ZA: "ZAF",
  EG: "EGY",
  AR: "ARG",
  CL: "CHL",
  CO: "COL",
  PE: "PER",
  VE: "VEN",
  UA: "UKR",
  CZ: "CZE",
  HU: "HUN",
  RO: "ROU",
  BG: "BGR",
  HR: "HRV",
  RS: "SRB",
  SK: "SVK",
  SI: "SVN",
  LT: "LTU",
  LV: "LVA",
  EE: "EST",
  IS: "ISL",
  LU: "LUX",
  MT: "MLT",
  CY: "CYP",
  MO: "MAC",
  BD: "BGD",
  PK: "PAK",
  LK: "LKA",
  MM: "MMR",
  NP: "NPL",
  KH: "KHM",
  LA: "LAO",
  BN: "BRN",
  MN: "MNG",
  KZ: "KAZ",
  UZ: "UZB",
  QA: "QAT",
  KW: "KWT",
  BH: "BHR",
  OM: "OMN",
  JO: "JOR",
  LB: "LBN",
  SY: "SYR",
  IQ: "IRQ",
  IR: "IRN",
  AF: "AFG",
  PS: "PSE",
  YE: "YEM",
  LY: "LBY",
  TN: "TUN",
  DZ: "DZA",
  MA: "MAR",
  SD: "SDN",
  ET: "ETH",
  KE: "KEN",
  UG: "UGA",
  TZ: "TZA",
  GH: "GHA",
  NG: "NGA",
  SN: "SEN",
  CM: "CMR",
};